//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FieldSalesTab from "@/pages/SalesDashboard/components/FieldSalesTab.vue";
import LabelsDialog from "@/components/RightDrawer/LabelsDialog.vue";
import moment from "moment";
import BackendServices from "@/services/backend-services.js";
import { EventBus } from "@/event-bus.js";

export default {
  name: "SalesDashboard",
  components: {
    FieldSalesTab,
    LabelsDialog,
  },
  props: ["secTab"],
  mounted: async function () {
    this.retailerList = await BackendServices.getRetailers().data;
    this.$store.commit("setDatePickerState", false);
  },
  data: () => ({
    moment,
    toggleGraph: false,
    value: 0 | null,
    prevValue: 0,
    tab: 1,
    seamlessLabels: false,
  }),
  methods: {
    clearData: function () {
      EventBus.$emit("clear-dashboard");
    },
    expandDrawer: function () {
      this.seamlessLabels = true;
      this.$store.commit("toggleRightDrawer");
    },
  },
  computed: {},
  watch: {},
};
